if (!customElements.get('swk-product-gallery')) {
  customElements.define(
    'swk-product-gallery',
    class SwkProductGallery extends HTMLElement {
      connectedCallback() {
        this.initSwiper();
      }

      disconnectedCallback() {
        this.destroySwiper();
      }

      initSwiper() {
        if (this.swiper) return;

        const swiperEl = this.querySelector('.swk-product__gallery-swiper');
        const paginationEl = this.querySelector('.swk-product__gallery-pagination');
        if (!swiperEl) return;

        const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
        if (slideCount <= 1) {
          this.classList.add('swk-product__gallery--single');
          return;
        }

        if (typeof Swiper === 'undefined') {
          window.addEventListener('load', () => this.initSwiper(), { once: true });
          return;
        }

        this.swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          speed: 500,
          observer: true,
          observeParents: true,
          resizeObserver: true,
          pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet(index, className) {
              return `<span class="${className} swk-product__gallery-pagination-bar" aria-label="Slide ${index + 1}"></span>`;
            },
          },
        });
      }

      destroySwiper() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}

if (!customElements.get('swk-product-form')) {
  customElements.define(
    'swk-product-form',
    class SwkProductForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.buyNowButton = this.querySelector('[data-buy-now]');
        this.buyNowButton?.addEventListener('click', this.onBuyNow.bind(this));
      }

      async onBuyNow(event) {
        event.preventDefault();

        const form = this.form;
        if (!form) return;

        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton?.disabled) return;

        const formData = new FormData(form);
        this.buyNowButton.setAttribute('aria-disabled', 'true');
        this.buyNowButton.classList.add('loading');

        try {
          const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });

          if (!response.ok) throw new Error('Add to cart failed');

          window.location.href = '/checkout';
        } catch (error) {
          this.buyNowButton.removeAttribute('aria-disabled');
          this.buyNowButton.classList.remove('loading');
        }
      }
    }
  );
}
